(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Sistema', Sistema);

    Sistema.$inject = ['$resource'];

    function Sistema ($resource) {
        var resourceUrl =  'api/sistemas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
